module.exports = __webpack_public_path__ + "img/main_partner_reference.403a5b30.png";